import {
    PudoTransactionVolumeBySlotDimensionDonutChart as PudoTransactionVolumeBySlotDimensionDonutChartRenderer,
    hasChartSeries
} from '@frontend/chart/components';
import { PudoTransactionVolumeBySlotDimensionDonutChart } from '@frontend/chart/components';
import { CommonMessage } from '@frontend/lang';
import { FormattedMessage } from 'react-intl';

import { InsightCardWidth } from '../insight-card-width';
import { InsightCard } from '../insight-card/insight-card.component';
import { useInsightChartMinHeight } from '../insight-detail-mode.context';
import { InsightId } from '../insight-registry/insight-ids';
import { usePudoCompartmentUsageBySizeDonutChart } from './use-pudo-compartment-usage-by-size-donut-chart';

export interface PudoCompartmentUsageBySizeDonutChartProps {
    accountId: string;
    width?: InsightCardWidth;
}

export const PudoCompartmentUsageBySizeDonutChart = ({ accountId, width }: PudoCompartmentUsageBySizeDonutChartProps) => {
    const chartMinHeight = useInsightChartMinHeight(280);
    const { data, isLoading } = usePudoCompartmentUsageBySizeDonutChart(accountId);

    return (
        <InsightCard
            insightId={InsightId.PUDO_COMPARTMENT_USAGE_BY_SIZE}
            chartKey={PudoTransactionVolumeBySlotDimensionDonutChart.definition.key}
            width={width}
            title={
                <FormattedMessage
                    id='platform.analytics.insights.pudo-compartment-usage-by-size-donut-chart.slot-usage-title'
                    description='Title for the PuDo SLOT usage-by-size donut chart on analytics insights'
                    defaultMessage='SLOT usage by size'
                />
            }
            subtitle={
                <FormattedMessage
                    id='platform.analytics.insights.pudo-compartment-usage-by-size-donut-chart.subtitle'
                    description='Subtitle indicating compartment usage by size covers the last 30 days of PuDo transaction volume grouped by SLOT dimension'
                    defaultMessage='last 30 days'
                />
            }
            isLoading={isLoading}>
            {!hasChartSeries(data) || !data ? (
                <div className='text-foreground-default'>{CommonMessage.ERRORS.NO_DATA_AVAILABLE}</div>
            ) : (
                <div className='w-full min-w-0'>
                    <PudoTransactionVolumeBySlotDimensionDonutChartRenderer
                        data={data}
                        showSliceValues
                        minHeight={chartMinHeight}
                    />
                </div>
            )}
        </InsightCard>
    );
};
